import { Chart, SeriesTemplate, CommonSeriesSettings, ArgumentAxis, ValueAxis, Tooltip, Legend, Export, CommonAxisSettings } from "devextreme-react/chart";
import { loadMessages, locale } from "devextreme/localization";
import * as messagesFr from "devextreme/localization/messages/fr.json";
import useChartData from "../../../../hooks/use-chart-data.ts";
import SimpleLoadingIndicator from "../../../../components/simple-loading-indicator";

export interface WeeklyDataChartProps {
    selectedLocalisation: number;
    selectedOption: string;
    selectedDateRange: Date[]
}

const WeeklyDataChart = ({ selectedLocalisation, selectedOption, selectedDateRange}: WeeklyDataChartProps) => {
    const startDate = selectedDateRange[0];
    const endDate = selectedDateRange[1];
    
    const {data, isLoading} = useChartData(selectedLocalisation, startDate, endDate, selectedOption);
    
    loadMessages(messagesFr);
    locale("fr");

    // Calculer la plage visuelle
    const startValue = new Date(startDate);
    startValue.setDate(startValue.getDate() - 7 - startValue.getDay() + 1); // Reculer d'une semaine et aller au lundi précédent
    const endValue = new Date(endDate);
    endValue.setDate(endValue.getDate() + (7 - endValue.getDay()) + 7); // Aller au dimanche suivant et avancer d'une semaine
    
    return (
        <div className='relative'>
            <Chart id="chart" dataSource={data}>
                <ArgumentAxis
                    label={{ format: "month" }}
                    argumentType="datetime"
                    tickInterval="week"
                    minorTick={{ visible: true }}
                    minorTickInterval="week"
                    aggregationInterval="week"
                    visualRange={{ startValue, endValue }}
                >
                </ArgumentAxis>

                <ValueAxis allowDecimals={false} />

                <CommonAxisSettings aggregatedPointsPosition="crossTicks" />

                <CommonSeriesSettings
                    argumentField="argument"
                    valueField="value"
                    type="stackedbar"
                />

                <SeriesTemplate
                    nameField="serieName"
                />

                <Export enabled={false} />

                <Tooltip
                    enabled={true}
                    location="edge"
                    customizeTooltip={(arg) => ({
                        text: `${arg.value.toFixed(2)}\n${new Intl.DateTimeFormat("fr-FR", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric"
                        }).format(new Date(arg.argument))}`,
                    })}
                />

                <Legend
                    visible={false}
                    position="outside"
                    horizontalAlignment="center"
                    verticalAlignment="bottom"
                />
            </Chart>

            {isLoading &&
                <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'>
                    <SimpleLoadingIndicator text={'Chargement du diagramme'}/>
                </div>}
      
        </div>
    );
};

export default WeeklyDataChart;